import axios from 'axios';

const mid = sessionStorage.getItem('mid') || null;
const token = sessionStorage.getItem('token') || null;
const csrfTokenFromMeta = document.querySelector('meta[name="csrf-token"]').content;

export const checkoutPost = (product, data, csrfToken) => {
    let checkoutRequest = axios.create();
    checkoutRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    checkoutRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    if (mid && token && false) {
        checkoutRequest.defaults.headers.common['X-SEHSEH-Mid'] = mid;
        checkoutRequest.defaults.headers.common['X-SEHSEH-Token'] = token;
    }
    return checkoutRequest.post(`/api/checkout/${product}/new`, data);
};